import { useCallback } from 'react'
import { UserSelectUser } from '../types'

/**
 * a callback to transform a user into the label property for the UserSelect's
 * LabeledValueType
 */
export function useUserSelectLabel() {
  const callback = useCallback<(user: UserSelectLabelUser) => string>(
    ({ displayName, mail }) => {
      return displayName ?? mail
    },
    []
  )

  return callback
}

export type UserSelectLabelUser = Pick<
  UserSelectUser,
  '__typename' | 'mail' | 'displayName'
>
